module.exports = __webpack_public_path__ + "media/assets/images/blog/controller_switches-b74a6b76954118445110a9793fa6ab7e.jpg";